import React from "react";

/**
 * PTE Connect brand mark.
 *
 * Variants:
 *   - default (full): "PTE" lightning lockup + gauge stacked vertically — used in the
 *     login hero & wide brand surfaces.
 *   - compact: just the gauge mark — used in the collapsed sidebar / favicon-like slots.
 *
 * The `dark` prop is retained for API compatibility; the new logos are designed
 * to sit on dark surfaces so it currently doesn't change the asset, only the
 * accompanying word-mark colour.
 */
export function Logo({ scale = 1, dark = true, compact = false }) {
  const s = scale;
  if (compact) {
    // Gauge only — perfect for collapsed sidebar (square-ish mark)
    return (
      <img
        src="/brand/pte-gauge.png"
        alt="PTE Connect"
        width={32 * s}
        height={32 * s}
        style={{ display: "block", objectFit: "contain" }}
      />
    );
  }
  // Lightning PTE word-mark + Connect text underneath
  return (
    <div
      aria-label="PTE Connect"
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 2,
        lineHeight: 1,
      }}
    >
      <img
        src="/brand/pte-lightning.png"
        alt=""
        width={112 * s}
        height={64 * s}
        style={{ display: "block", objectFit: "contain", marginLeft: -6 * s }}
      />
      <div
        style={{
          fontSize: 13 * s,
          fontWeight: 600,
          letterSpacing: ".34em",
          textTransform: "uppercase",
          color: dark ? "#E4C264" : "#8E7029",
          paddingLeft: 4 * s,
        }}
      >
        Connect
      </div>
    </div>
  );
}
